import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as types from './direct-routes-handler-constants';

export const redirectInfo = handleActions(
  {
    [combineActions(
      types.GET_REDIRECT_INFO_REQUEST,
      types.GET_REDIRECT_INFO_FAILURE,
    )]: () => ({}),
    [types.GET_REDIRECT_INFO_SUCCESS]: (state, { payload }) => payload,
  },
  {},
);

export const isLoading = handleActions(
  {
    [types.GET_REDIRECT_INFO_REQUEST]: () => true,
    [combineActions(
      types.GET_REDIRECT_INFO_SUCCESS,
      types.GET_REDIRECT_INFO_FAILURE,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      types.GET_REDIRECT_INFO_REQUEST,
      types.GET_REDIRECT_INFO_SUCCESS,
    )]: () => ({}),
    [types.GET_REDIRECT_INFO_FAILURE]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  redirectInfo,
  isLoading,
  error,
});
